import type { QueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { toast } from 'sonner';
import { formatCount } from '@/utils/number';
import { pcmpProposalQueryKeys } from '../api/pcmpProposals.api';
import type { PcmpProposalEditResult } from '../types/pcmpProposal.types';

// The API answers 403/409 when the proposal moved on (approved, held, the
// project ended) since the page loaded: refresh it so the buttons follow.
const STALE_DETAIL_STATUSES = new Set([403, 409]);

/**
 * Success and error handling shared by the section edits and the payment
 * source change. Errors stay in the dialog (shown inline), never a toast.
 */
export function pcmpProposalEditCallbacks(
  queryClient: QueryClient,
  proposalId: number,
  successTitle: string,
  onSuccess: () => void,
) {
  return {
    onSuccess: (result: PcmpProposalEditResult) => {
      for (const id of new Set([proposalId, ...result.affectedProposalIds])) {
        void queryClient.invalidateQueries({ queryKey: pcmpProposalQueryKeys.detail(id) });
      }
      toast.success(successTitle, {
        description: formatCount(Object.keys(result.changes).length, 'change'),
      });
      onSuccess();
    },
    onError: (error: unknown) => {
      const status = axios.isAxiosError(error) ? error.response?.status : undefined;
      if (status !== undefined && STALE_DETAIL_STATUSES.has(status)) {
        void queryClient.invalidateQueries({ queryKey: pcmpProposalQueryKeys.detail(proposalId) });
      }
    },
  };
}
